export default "__VITE_ASSET__DqDho6cm__"